import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full overflow-hidden border-b border-navy-100 bg-white" data-id="element-141" data-mp="7yl0ezv7mm53">
      <div aria-hidden="true" className="pointer-events-none absolute -right-32 -top-40 h-[26rem] w-[26rem] rounded-full bg-brand-violet/10 blur-3xl" data-id="element-142" data-mp="cxxnnlpztv87" />
      <div aria-hidden="true" className="pointer-events-none absolute -left-40 top-40 h-[22rem] w-[22rem] rounded-full bg-brand-cyan/10 blur-3xl" data-id="element-143" data-mp="mtitjuy6nfn8" />

      <div className="relative mx-auto max-w-content px-6 py-24 sm:py-32" data-id="element-144" data-mp="vm2mcersmq05">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="max-w-3xl" data-id="element-145" data-mp="10l5rs0boqy8n">
          <p className="inline-flex items-center rounded-full border border-brand-indigo/20 bg-brand-indigo/5 px-3.5 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-brand-indigo" data-id="element-146" data-mp="1ajd3o4r4aq3s">
            Digital publishing & e-commerce
          </p>
          <h1 className="mt-6 text-4xl font-bold leading-[1.15] tracking-tight text-navy-800 sm:text-5xl lg:text-[3.4rem]" data-id="element-147" data-mp="4n51wsd4x2dn">
            Digital products designed to educate, inspire and{' '}
            <span className="text-brand-violet" data-id="element-148" data-mp="3rv09q2vgzyj4">entertain.</span>
          </h1>
          <span aria-hidden="true" className="mt-7 block h-1 w-24 rounded-full bg-gradient-to-r from-brand-cyan via-brand-indigo to-brand-violet" data-id="element-149" data-mp="sd90umfdodyb" />
          <p className="mt-7 max-w-2xl text-lg leading-relaxed text-navy-500" data-id="element-150" data-mp="inz7l38ssp8m">
            Atlas Digital Hub creates and distributes high-quality digital
            resources, educational materials, printable content, creative tools
            and digital entertainment products for customers around the world.
          </p>

          <div className="mt-9" data-id="element-151" data-mp="16da3o7f7dvgf">
            <Link to="/what-we-offer" className="inline-flex items-center justify-center rounded-lg border border-brand-indigo/30 bg-white px-6 py-3.5 text-sm font-semibold text-brand-indigo transition-colors hover:border-brand-indigo hover:bg-brand-indigo/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-indigo focus-visible:ring-offset-2" data-id="element-152" data-mp="16bz28e98czsh">
              Learn More
            </Link>
          </div>

          <div className="mt-10 flex items-start gap-3 rounded-xl border border-brand-cyan/30 bg-brand-cyan/[0.06] p-4 sm:max-w-xl" data-id="element-153" data-mp="2humre64bsmb5">
            <ShieldCheckIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-brand-indigo" aria-hidden="true" data-id="element-154" data-mp="2msfvmtm2j68s" />
            <p className="text-sm leading-relaxed text-navy-600" data-id="element-155" data-mp="2cvjmqms9ci3p">
              We specialize in digital-only products delivered electronically.
              No physical items are shipped.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}